import React, { useState, useEffect } from "react"
import { connect } from "react-redux"
import { useHistory } from "react-router-dom"
import styled from "styled-components"
import { post, get } from "../../../netApi/fetch"

import ipUpload from "./../../../images/ipUpload.png"

import { message, Spin } from "antd"
import { confirm } from "../../Method/Confirm"
import { PlayCircleOutlined, PauseCircleOutlined, RightOutlined } from "@ant-design/icons"

// 创建样式组件

const DivContainer = styled.div`
  position: relative;
  width: 100%;
  margin: 20px auto;
  border: 1px solid rgb(240 240 240);
  padding: 12px;
  background: rgba(255, 255, 255, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  height: 120px;
  width: 480px;
  transition: border-color 0.3s;
  opacity: 0;
  animation: fadeIn 0.5s ease-in forwards;
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  &:hover {
    border-color: var(--theme-main);
  }

  input {
    display: none;
  }
`

// 新增视频容器样式
const VideosContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  max-width: 480px;
  margin: 0 auto;
`

const VideoItem = styled.div`
  position: relative;
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition:
    transform 0.3s,
    box-shadow 0.3s;
  cursor: pointer;
`

const VideoPlayer = styled.video`
  width: 100%;
  height: 320px;
  object-fit: cover;
  border-radius: 12px;
  background: #000;
`

const VideoInfo = styled.div`
  padding: 12px;
  background: #fff;
`

const VideoTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const VideoTime = styled.div`
  font-size: 12px;
  color: #999;
  margin-bottom: 8px;
`

const DeleteButton = styled.button`
  padding: 4px 8px;
  border: 1px solid var(--theme-main);
  border-radius: 10px;
  background: #fff;
  color: var(--theme-main);
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    background: var(--theme-main-hover-deep);
    color: #fff;
  }
`

const LoadingText = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 10px;
  font-size: 14px;
  font-weight: 600;
  width: 100%;
  max-width: 300px;
  margin: 20px auto;
  display: block;
  text-align: center;
  color: #ccc;
`

// 音频列表样式
const SoundList = styled.div`
  display: flex;
  gap: 12px;
  overflow-x: auto;
  padding: 12px 0;
  max-height: 140px;

  /* 滚动条样式 */
  &::-webkit-scrollbar {
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`

const SoundItem = styled.div`
  flex: 0 0 140px;
  border: 2px solid #e8e8e8;
  border-radius: 12px;
  background: #fff;
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: hidden;
/* 
  &:hover {
    border-color: #d0d0d0;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  &.selected {
    border-color: var(--theme-main);
    box-shadow: 0 4px 12px rgba(24, 144, 255, 0.2);
  } */
`

const SoundInfo = styled.div`
  padding: 12px;
  background: #fff;
`

const SoundTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const SoundTime = styled.div`
  font-size: 12px;
  color: #999;
  margin-bottom: 8px;
`

const SoundLoadMoreButton = styled.div`
  flex: 0 0 80px;
  height: 100px;
  border: 2px dashed #d0d0d0;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  color: #999;

  &:hover {
    border-color: var(--theme-main);
    color: var(--theme-main);

    .load-more-icon {
      transform: translateX(4px);
    }
  }

  .load-more-icon {
    font-size: 20px;
    transition: transform 0.3s ease;
  }
`

// function DialogPage(props: { user: user; loginBindInfo: loginBindInfo }) {
function DialogPage(props) {
  const [messageApi, contextHolder] = message.useMessage()
  const history = useHistory()
  const isLogin = props.user && props.user.uid

  const [viewOffsetIndex, setViewOffsetIndex] = useState(0)
  const [viewLength, setViewLength] = useState<number>(null)
  const [contentList, setContentList] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const limit = 10

  // 音频列表状态
  const [soundList, setSoundList] = useState<any[]>([])
  const [soundOffsetIndex, setSoundOffsetIndex] = useState(0)
  const [soundLength, setSoundLength] = useState<number>(null)
  const [soundLoading, setSoundLoading] = useState(false)
  const [isPlaying, setIsPlaying] = useState(false)
  const audioRef = React.useRef<HTMLAudioElement | null>(null)
  const soundListRef = React.useRef<HTMLDivElement | null>(null)
  const soundLimit = 5

  const arrivedBottom = () => {
    if (viewLength == null) return false
    return viewOffsetIndex * limit >= viewLength
  }

  // 检查是否滚动到底部的函数
  const isScrollToBottom = () => {
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
    const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
    const clientHeight = document.documentElement.clientHeight || document.body.clientHeight
    return scrollTop + clientHeight >= scrollHeight - 50 // 提前50px开始加载
  }

  // 滚动事件处理器
  const handleScroll = () => {
    if (isScrollToBottom() && isLogin) {
      if (!arrivedBottom() && !isLoading) {
        handleGetContentList()
      }
      if (!arrivedSoundBottom() && !soundLoading) {
        handleGetSoundList()
      }
    }
  }

  const handleDeleteVideo = (id, e) => {
    // 弹窗警告
    confirm({ text: "确定删除该视频吗?" }).then((res) => {
      if (res) {
        post(`/ip/deletemp4`, { id }).then(() => {
          messageApi.success("删除成功")
          // 重新加载视频列表
          refreshContentList()
        })
      } else {
        console.log("取消删除")
      }
    })
  }

  // 重置列表并加载第一页（强制）
  const refreshContentList = () => {
    setIsLoading(true)
    setViewOffsetIndex(0)
    setContentList([])

    get(`/ip/viewmp4list?offset=0&limit=${limit}`, {})
      .then((res) => {
        setViewLength(res.count)
        setContentList(res.list)
        setViewOffsetIndex(1)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  const handleGetContentList = (reset = false) => {
    if (isLoading) return // 防止重复请求

    if (reset) {
      refreshContentList()
      return
    }

    setIsLoading(true)
    const offset = viewOffsetIndex * limit
    get(`/ip/viewmp4list?offset=${offset}&limit=${limit}`, {})
      .then((res) => {
        setViewLength(res.count)
        setContentList((prevContentList) => [...prevContentList, ...res.list])
        setViewOffsetIndex((prevIndex) => prevIndex + 1)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  // 音频列表相关函数
  const arrivedSoundBottom = () => {
    if (soundLength == null) return false
    return soundOffsetIndex * soundLimit >= soundLength
  }

  const refreshSoundList = () => {
    setSoundLoading(true)
    setSoundOffsetIndex(0)
    setSoundList([])

    get(`/ip/viewmp3list?offset=0&limit=${soundLimit}`, {})
      .then((res) => {
        setSoundList(res.list)
        setSoundOffsetIndex(1)
        setSoundLength(res.count)
      })
      .finally(() => {
        setSoundLoading(false)
      })
  }

  const handleGetSoundList = (reset = false) => {
    if (soundLoading) return

    if (reset) {
      refreshSoundList()
      return
    }

    setSoundLoading(true)
    const offset = soundOffsetIndex * soundLimit
    get(`/ip/viewmp3list?offset=${offset}&limit=${soundLimit}`, {})
      .then((res) => {
        setSoundList((prevSoundList) => [...prevSoundList, ...res.list])
        setSoundOffsetIndex((prevIndex) => prevIndex + 1)
        setSoundLength(res.count)
      })
      .finally(() => {
        setSoundLoading(false)
      })
  }

  useEffect(() => {
    handleGetContentList(true)
    handleGetSoundList(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // 手动注册wheel事件监听器，设置passive: false
  useEffect(() => {
    const soundListElement = soundListRef.current
    if (!soundListElement) return

    const handleWheel = (e: WheelEvent) => {
      e.preventDefault()
      soundListElement.scrollLeft += e.deltaY
    }

    soundListElement.addEventListener("wheel", handleWheel, { passive: false })

    return () => {
      soundListElement.removeEventListener("wheel", handleWheel)
    }
  }, [soundList])

  // 监听滚动事件
  useEffect(() => {
    window.addEventListener("scroll", handleScroll)
    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [viewOffsetIndex, viewLength, isLoading, isLogin])

  const UploadSvg = () => (
    <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="50.000000" height="50.000000" fill="none">
      <defs>
        <image id="image_4" width="200.000000" height="200.000000" xlinkHref={ipUpload} />
        <pattern id="pattern_4" width="1.000000" height="1.000000" image-fill-type="fill" patternContentUnits="objectBoundingBox">
          <use transform="matrix(0.005,0,0,0.005,0,0)" xlinkHref="#image_4" />
        </pattern>
      </defs>
      <rect id="上传" width="100.000000" height="100.000000" x="0.000000" y="0.000000" fill="url(#pattern_4)" />
    </svg>
  )

  return (
    <>
      {contextHolder}
      <div style={{ margin: "0 auto" }}>
        <div className="flex-center" style={{ flexWrap: "wrap" }}>
          <DivContainer onClick={() => history.push("/voice-clone")}>
            <LeftContainer>
              <UploadSvg />
              <div>AI克隆你的IP音频</div>
            </LeftContainer>
          </DivContainer>
        </div>
      </div>
      <div style={{ margin: "0 auto" }}>
        <div className="flex-center" style={{ flexWrap: "wrap" }}>
          <DivContainer onClick={() => history.push("/video-clone")}>
            <LeftContainer>
              <UploadSvg />
              <div>AI克隆你的IP视频</div>
            </LeftContainer>
          </DivContainer>
        </div>
      </div>

      {/* 音频列表展示 */}
      {isLogin && (
        <>
          <div style={{ maxWidth: 480, margin: "40px auto 20px", textAlign: "center" }}>
            <h2 style={{ fontSize: "20px", fontWeight: "600", color: "#333" }}>我的音频</h2>
          </div>
          <div style={{ maxWidth: 480, margin: "0 auto" }}>
            {soundLoading && soundList.length === 0 ? (
              <div style={{ height: 120, display: "flex", alignItems: "center", justifyContent: "center" }}>
                <Spin />
              </div>
            ) : (
              <SoundList ref={soundListRef}>
                {soundList.map((item) => (
                  <SoundItem key={`sound_${item.id}`}>
                    <SoundInfo>
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                        <div style={{ flex: 1, width: "93px" }}>
                          <SoundTitle>{item.filename || "音频文件"}</SoundTitle>
                          <SoundTime>{item.updatetime}</SoundTime>
                        </div>
                        <button
                          onClick={(e) => {
                            e.stopPropagation()
                            if (audioRef.current) {
                              if (isPlaying && audioRef.current.src === item.url) {
                                audioRef.current.pause()
                                setIsPlaying(false)
                              } else {
                                audioRef.current.src = item.url
                                audioRef.current.play()
                                setIsPlaying(true)
                              }
                            }
                          }}
                          style={{
                            cursor: "pointer",
                            borderRadius: "50vmin",
                            background: "var(--theme-main)",
                            color: "#fff",
                            padding: "4px 8px",
                            fontSize: "12px",
                            border: "none",
                            fontWeight: "bold",
                            opacity: item.url ? 1 : 0.5,
                          }}
                          disabled={!item.url}
                        >
                          {isPlaying && audioRef.current?.src === item.url ? <PauseCircleOutlined /> : <PlayCircleOutlined />}
                        </button>
                      </div>
                    </SoundInfo>
                  </SoundItem>
                ))}
                {soundList.length < soundLength && (
                  <SoundLoadMoreButton onClick={() => handleGetSoundList()}>
                    <RightOutlined className="load-more-icon" />
                  </SoundLoadMoreButton>
                )}
              </SoundList>
            )}
            <audio
              ref={audioRef}
              onEnded={() => setIsPlaying(false)}
              onError={() => {
                setIsPlaying(false)
              }}
            />
          </div>
        </>
      )}

      {/* 视频列表展示 */}
      <div style={{ maxWidth: 480, margin: "40px auto 20px", textAlign: "center" }}>
        <h2 style={{ fontSize: "20px", fontWeight: "600", color: "#333" }}>我的视频</h2>
      </div>
      <VideosContainer>
        {contentList.map((item) => (
          <VideoItem key={`video_${item.id}`}>
            <VideoPlayer controls>
              <source src={item.url} />
              您的浏览器不支持视频播放
            </VideoPlayer>
            <VideoInfo>
              <div style={{ float: "left", width: 160 }}>
                <VideoTitle>{item.filename}</VideoTitle>
                <VideoTime>{item.updatetime}</VideoTime>
              </div>
              <DeleteButton style={{ float: "right" }} onClick={(e) => handleDeleteVideo(item.id, e)}>
                删除
              </DeleteButton>
            </VideoInfo>
          </VideoItem>
        ))}
      </VideosContainer>

      {/* 加载状态提示 */}
      {!arrivedBottom() && isLogin && <LoadingText>{isLoading ? "加载中..." : "滚动到底部加载更多"}</LoadingText>}
      {!isLogin && <LoadingText>请登录后查看</LoadingText>}
      {arrivedBottom() && isLogin && contentList.length > 0 && <LoadingText>已加载全部内容</LoadingText>}
    </>
  )
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {}
}

const mapStateToProps = (state, ownProps) => {
  return {
    user: state.login_user_data,
    loginBindInfo: state.loginBindInfo,
  }
}

// 添加LeftContainer和RightLabelContainer的定义
const LeftContainer = styled.div`
  display: flex;
  align-items: center;
  & > *:not(:last-child) {
    margin-right: 12px;
  }
`

export default connect(mapStateToProps, mapDispatchToProps)(DialogPage)
